import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { KEYS_FIELDS_QUESTION } from 'constants/materialAssessment';
import getValueChainNames from 'utils/valueChainHelpers';

import type IStakeholderGroupsQuestionsItem from 'store/slices/materialAssessment/interfaces/IStakeholderGroupsQuestionsItem';
import type IRefinementQuestionsTable from './interfaces/IRefinementQuestionsTable';

import styles from './scss/RefinementQuestionsTable.module.scss';

function RefinementQuestionsTable({
  headCells,
  items,
  hasMore,
  loadMore,
}: Readonly<IRefinementQuestionsTable>) {
  const { t } = useTranslation();

  const CELL_ID_TO_KEY: Record<string, string> = {
    questionGroup: KEYS_FIELDS_QUESTION.QUESTION_GROUP,
    questionType: KEYS_FIELDS_QUESTION.QUESTION,
    questionSourceType: KEYS_FIELDS_QUESTION.SOURCE,
    companyName: KEYS_FIELDS_QUESTION.COMPANY_NAME,
    source: KEYS_FIELDS_QUESTION.EVIDENCE_SOURCE,
    valueChainName: KEYS_FIELDS_QUESTION.VALUE_CHAIN,
  };

  const renderCell = (item: IStakeholderGroupsQuestionsItem, cellId: string) => {
    const key = CELL_ID_TO_KEY[cellId] ?? cellId;
    switch (key) {
      case KEYS_FIELDS_QUESTION.QUESTION:
        return (
          <span className={styles.questionType}>
            {item.type || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.SOURCE:
        return (
          <span className={styles.questionSourceType}>
            {item.sourceType || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.COMPANY_NAME:
        return (
          <span className={styles.companyName}>
            {item.companyName || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.EVIDENCE_SOURCE:
        return (
          <span className={styles.source}>
            {item.source || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.QUESTION_GROUP:
        return (
          <span className={styles.cellLabel}>
            {item.title || '-'}
          </span>

        );
      case KEYS_FIELDS_QUESTION.VALUE_CHAIN:
        return (
          <span className={styles.source}>
            {getValueChainNames(item.valueChainMapIds, undefined)}
          </span>
        );
      default:
        return '-';
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.tableScrollWrapper}>
        <div className={styles.tableHeader}>
          {headCells.map(({ id, label }) => (
            <div key={id} className={styles.headerCell}>
              <span>{t(label)}</span>
            </div>
          ))}
        </div>
        <InfiniteScroll
          dataLength={items.length}
          next={loadMore}
          hasMore={hasMore}
          loader={null}
          scrollableTarget="refinement-questions-scroll"
        >
          <div className={styles.tableBodyScroll} id="refinement-questions-scroll">
            <div className={styles.tableBody}>
              {items.length > 0
                ? items.map((item, index) => (
                  <div key={[item.id, index].join('_')} className={styles.tableRow}>
                    {headCells.map((cell) => (
                      <div key={cell.id} className={styles.tableCell}>
                        {renderCell(item, cell.id)}
                      </div>
                    ))}
                  </div>
                ))
                : null}
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
}

export default RefinementQuestionsTable;
